import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { PharmacyQueueInstitution } from '@shared/services/pharmacyQueue/types/getPharmacyQueueInstitutions.type';
import type { PharmacyQueuePharmacy } from '@shared/services/pharmacyQueue/types/getPharmacyQueuePharmacies.type';

import { initialState } from './initialState';

const pharmacyQueueSlice = createSlice({
  initialState,
  name: 'pharmacyQueue',
  reducers: {
    resetPharmacyQueueState: () => initialState,
    setSelectedInstitution: (state, action: PayloadAction<PharmacyQueueInstitution>) => {
      state.selectedInstitution = action.payload;
      state.selectedPharmacy = null;
    },
    setSelectedPharmacy: (state, action: PayloadAction<PharmacyQueuePharmacy>) => {
      state.selectedPharmacy = action.payload;
    },
    setQueueNumber: (state, action: PayloadAction<null | string>) => {
      state.queueNumber = action.payload;
    },
  },
});

export const pharmacyQueueAction = pharmacyQueueSlice.actions;
export default pharmacyQueueSlice.reducer;
